const TAB_ID = `tab_${Date.now()}`;

export const initializeTab = (): void => {
  sessionStorage.setItem(TAB_ID, 'active');
};

export const isLastTab = (): boolean => {
  return Object.keys(sessionStorage).filter(key => key.startsWith('tab_')).length === 1;
};

export const cleanupTab = (): void => {
  sessionStorage.removeItem(TAB_ID);
  if (isLastTab()) {
    localStorage.setItem('i_ov', 'false');
    sessionStorage.clear();
  }
};

window.addEventListener('beforeunload', () => {
  cleanupTab();
});

initializeTab();